// This file was automatically generated and should not be edited.

// ====================================================
// Domain Graph Type Identity and ID Prefix Mapping
// ====================================================

import {objectFromEntries} from '@benchling/js-utils';

import {CoreObjectIdPrefix, ObjectType} from 'app-core/framework/CoreObjectConstants';

/** @package */
export const GeneratedDomainGraphType = {
  AA_SEQUENCE: 'AA_SEQUENCE',
  AA_SEQUENCE_SCHEMA: 'AA_SEQUENCE_SCHEMA',
  ANALYSIS: 'ANALYSIS',
  ANALYSIS_TEMPLATE: 'ANALYSIS_TEMPLATE',
  ANALYSIS_TEMPLATE_DATA_FRAME_VARIABLE: 'ANALYSIS_TEMPLATE_DATA_FRAME_VARIABLE',
  ANALYSIS_TEMPLATE_VARIABLE: 'ANALYSIS_TEMPLATE_VARIABLE',
  ANTIBODY: 'ANTIBODY',
  ANTIBODY_FORMAT: 'ANTIBODY_FORMAT',
  ASSEMBLY: 'ASSEMBLY',
  BENCHLING_OBJECT_SCHEMA_V2: 'BENCHLING_OBJECT_SCHEMA_V2',
  BLOCK_VISUALIZATION: 'BLOCK_VISUALIZATION',
  BOX: 'BOX',
  BOX_SCHEMA: 'BOX_SCHEMA',
  BUSINESS_RULE: 'BUSINESS_RULE',
  CHART: 'CHART',
  CHAT_SESSION: 'CHAT_SESSION',
  COLLABORATION: 'COLLABORATION',
  CONFIG_IMPORT_HISTORY_ENTRY: 'CONFIG_IMPORT_HISTORY_ENTRY',
  CONTAINER: 'CONTAINER',
  CONTAINER_SCHEMA: 'CONTAINER_SCHEMA',
  CUSTOM_ENTITY: 'CUSTOM_ENTITY',
  CUSTOM_SCHEMA_INTERFACE: 'CUSTOM_SCHEMA_INTERFACE',
  DATASET: 'DATASET',
  DATA_FRAME: 'DATA_FRAME',
  DNA_OLIGO: 'DNA_OLIGO',
  DNA_SEQUENCE: 'DNA_SEQUENCE',
  DNA_SEQUENCE_SCHEMA: 'DNA_SEQUENCE_SCHEMA',
  DOCUMENT: 'DOCUMENT',
  DROPDOWN: 'DROPDOWN',
  ENTITY_SCHEMA: 'ENTITY_SCHEMA',
  ENTRY: 'ENTRY',
  ENTRY_SUBTEMPLATE: 'ENTRY_SUBTEMPLATE',
  ENTRY_TEMPLATE: 'ENTRY_TEMPLATE',
  ENZYME_LIST: 'ENZYME_LIST',
  EXAMPLE_TYPE: 'EXAMPLE_TYPE',
  FEATURE_LIBRARY: 'FEATURE_LIBRARY',
  FILE: 'FILE',
  FOLDER: 'FOLDER',
  FORM_DEFINITION: 'FORM_DEFINITION',
  INTERNAL_PIPELINE: 'INTERNAL_PIPELINE',
  JELLYFISH: 'JELLYFISH',
  JELLYFISH_SCHEMA: 'JELLYFISH_SCHEMA',
  LABEL_TEMPLATE: 'LABEL_TEMPLATE',
  LADDER: 'LADDER',
  LIBRARY_PARAMETER_DEFINITION: 'LIBRARY_PARAMETER_DEFINITION',
  LOCATION: 'LOCATION',
  LOCATION_SCHEMA: 'LOCATION_SCHEMA',
  MATRIX_PLATE: 'MATRIX_PLATE',
  MATRIX_PLATE_SCHEMA: 'MATRIX_PLATE_SCHEMA',
  MCP_SERVER_CONFIG: 'MCP_SERVER_CONFIG',
  MIXTURE: 'MIXTURE',
  MODEL_RUN: 'MODEL_RUN',
  MOLECULE: 'MOLECULE',
  NUCLEOTIDE_ALIGNMENT: 'NUCLEOTIDE_ALIGNMENT',
  OLIGO_CONJUGATE: 'OLIGO_CONJUGATE',
  OLIGO_DUPLEX: 'OLIGO_DUPLEX',
  PIPELINE_STEP: 'PIPELINE_STEP',
  PLATE: 'PLATE',
  PLATE_SCHEMA: 'PLATE_SCHEMA',
  POLICY: 'POLICY',
  PRINTER: 'PRINTER',
  PROCEDURE: 'PROCEDURE',
  PROCEDURE_FLOWCHART: 'PROCEDURE_FLOWCHART',
  PROCEDURE_FLOWCHART_CONFIG_VERSION_PROXY: 'PROCEDURE_FLOWCHART_CONFIG_VERSION_PROXY',
  PROCEDURE_FLOWCHART_VERSION: 'PROCEDURE_FLOWCHART_VERSION',
  PROCEDURE_METHOD_DEFINITION_VERSION: 'PROCEDURE_METHOD_DEFINITION_VERSION',
  PROCEDURE_METHOD_EXECUTION_INSTANCE: 'PROCEDURE_METHOD_EXECUTION_INSTANCE',
  PROCEDURE_METHOD_EXECUTION_INSTANCE_ASSOCIATION: 'PROCEDURE_METHOD_EXECUTION_INSTANCE_ASSOCIATION',
  PROCEDURE_PARAMETER: 'PROCEDURE_PARAMETER',
  PROCEDURE_PARAMETER_CONFIRMATION_VALUE: 'PROCEDURE_PARAMETER_CONFIRMATION_VALUE',
  PROCEDURE_PARAMETER_MEASURED_VALUE: 'PROCEDURE_PARAMETER_MEASURED_VALUE',
  PROCEDURE_PARAMETER_PLANNED_VALUE: 'PROCEDURE_PARAMETER_PLANNED_VALUE',
  PROCEDURE_PARAMETER_VERSION: 'PROCEDURE_PARAMETER_VERSION',
  PROCEDURE_RUN: 'PROCEDURE_RUN',
  PROCEDURE_RUN_CONDITION: 'PROCEDURE_RUN_CONDITION',
  PROCEDURE_RUN_CONDITION_REPLICATE: 'PROCEDURE_RUN_CONDITION_REPLICATE',
  PROCEDURE_RUN_PLAN: 'PROCEDURE_RUN_PLAN',
  PROCEDURE_RUN_PLAN_CONDITION: 'PROCEDURE_RUN_PLAN_CONDITION',
  PROCEDURE_STEP_DEFINITION_VERSION: 'PROCEDURE_STEP_DEFINITION_VERSION',
  PROCEDURE_STEP_EXECUTION_INSTANCE: 'PROCEDURE_STEP_EXECUTION_INSTANCE',
  PROJECT: 'PROJECT',
  PUBLISHING_RECORD: 'PUBLISHING_RECORD',
  REGISTRY: 'REGISTRY',
  REQUEST_SCHEMA: 'REQUEST_SCHEMA',
  REQUEST_TASK_SCHEMA: 'REQUEST_TASK_SCHEMA',
  REQUEST_V2_DEFINITION: 'REQUEST_V2_DEFINITION',
  REQUEST_V2_SUBMISSION: 'REQUEST_V2_SUBMISSION',
  RESULT: 'RESULT',
  RESULT_SCHEMA: 'RESULT_SCHEMA',
  RNA_OLIGO: 'RNA_OLIGO',
  RNA_SEQUENCE: 'RNA_SEQUENCE',
  RUN: 'RUN',
  RUN_SCHEMA: 'RUN_SCHEMA',
  SAMPLE_DEFINITION: 'SAMPLE_DEFINITION',
  SAMPLE_TYPE: 'SAMPLE_TYPE',
  SCRATCH_FILE: 'SCRATCH_FILE',
  SQL_DASHBOARD: 'SQL_DASHBOARD',
  SQL_DASHBOARD_BLOCK: 'SQL_DASHBOARD_BLOCK',
  SQL_DASHBOARD_LINK: 'SQL_DASHBOARD_LINK',
  STAGE_ENTRY: 'STAGE_ENTRY',
  STAR: 'STAR',
  STATIC_SCHEMA_INTERFACE: 'STATIC_SCHEMA_INTERFACE',
  STATIC_VALIDATION_RULE_TEMPLATE: 'STATIC_VALIDATION_RULE_TEMPLATE',
  STUDY: 'STUDY',
  STUDY_ITEM_ASSOCIATION: 'STUDY_ITEM_ASSOCIATION',
  STUDY_SAMPLE_TEST_PLAN: 'STUDY_SAMPLE_TEST_PLAN',
  STUDY_SCHEMA: 'STUDY_SCHEMA',
  TEAM: 'TEAM',
  TEMPLATE_COLLECTION: 'TEMPLATE_COLLECTION',
  TENANT_CONFIG: 'TENANT_CONFIG',
  TENTACLE: 'TENTACLE',
  TEST_DEFINITION: 'TEST_DEFINITION',
  TEST_ORDER: 'TEST_ORDER',
  TREATMENT_GROUP: 'TREATMENT_GROUP',
  TRIAL_SAMPLE_TESTING_STUDY_DESIGN: 'TRIAL_SAMPLE_TESTING_STUDY_DESIGN',
  UNIT: 'UNIT',
  UNIT_TYPE: 'UNIT_TYPE',
  USER: 'USER',
  VALIDATION_RULE: 'VALIDATION_RULE',
  WELL_PLATE: 'WELL_PLATE',
  WELL_PLATE_SCHEMA: 'WELL_PLATE_SCHEMA',
  WORKFLOW_END_NODE_DETAILS: 'WORKFLOW_END_NODE_DETAILS',
  WORKFLOW_FLOWCHART_CONFIG: 'WORKFLOW_FLOWCHART_CONFIG',
  WORKFLOW_FLOWCHART_CONFIG_VERSION: 'WORKFLOW_FLOWCHART_CONFIG_VERSION',
  WORKFLOW_FLOWCHART_EDGE_CONFIG: 'WORKFLOW_FLOWCHART_EDGE_CONFIG',
  WORKFLOW_FLOWCHART_NODE_CONFIG: 'WORKFLOW_FLOWCHART_NODE_CONFIG',
  WORKFLOW_OUTPUT: 'WORKFLOW_OUTPUT',
  WORKFLOW_OUTPUT_NODE_DETAILS: 'WORKFLOW_OUTPUT_NODE_DETAILS',
  WORKFLOW_OUTPUT_SCHEMA: 'WORKFLOW_OUTPUT_SCHEMA',
  WORKFLOW_ROOT_NODE_DETAILS: 'WORKFLOW_ROOT_NODE_DETAILS',
  WORKFLOW_ROUTER_FUNCTION: 'WORKFLOW_ROUTER_FUNCTION',
  WORKFLOW_ROUTER_NODE_DETAILS: 'WORKFLOW_ROUTER_NODE_DETAILS',
  WORKFLOW_TASK: 'WORKFLOW_TASK',
  WORKFLOW_TASK_DEFINITION: 'WORKFLOW_TASK_DEFINITION',
  WORKFLOW_TASK_DEFINITION_VERSION: 'WORKFLOW_TASK_DEFINITION_VERSION',
  WORKFLOW_TASK_GROUP: 'WORKFLOW_TASK_GROUP',
  WORKFLOW_TASK_NODE_DETAILS: 'WORKFLOW_TASK_NODE_DETAILS',
  WORKFLOW_TASK_SCHEMA: 'WORKFLOW_TASK_SCHEMA',
  WORKLIST: 'WORKLIST',
  WORKSHEET: 'WORKSHEET',
} as const;

/** @package */
export const ID_PREFIX_TO_DOMAIN_GRAPH_TYPES_ENTRIES = [
  ['abfmt', new Set([GeneratedDomainGraphType.ANTIBODY_FORMAT])],
  ['ana', new Set([GeneratedDomainGraphType.ANALYSIS])],
  ['anastep', new Set([GeneratedDomainGraphType.PIPELINE_STEP])],
  ['anatmpl', new Set([GeneratedDomainGraphType.ANALYSIS_TEMPLATE])],
  ['anatmpldfv', new Set([GeneratedDomainGraphType.ANALYSIS_TEMPLATE_DATA_FRAME_VARIABLE])],
  ['anatmplvar', new Set([GeneratedDomainGraphType.ANALYSIS_TEMPLATE_VARIABLE])],
  [
    'assaysch',
    new Set([
      GeneratedDomainGraphType.REQUEST_SCHEMA,
      GeneratedDomainGraphType.RESULT_SCHEMA,
      GeneratedDomainGraphType.RUN_SCHEMA,
    ]),
  ],
  ['assem', new Set([GeneratedDomainGraphType.ASSEMBLY])],
  ['axdash', new Set([GeneratedDomainGraphType.SQL_DASHBOARD])],
  ['axdlink', new Set([GeneratedDomainGraphType.SQL_DASHBOARD_LINK])],
  ['axquery', new Set([GeneratedDomainGraphType.SQL_DASHBOARD_BLOCK])],
  ['axvis', new Set([GeneratedDomainGraphType.BLOCK_VISUALIZATION])],
  [
    'bfi',
    new Set([
      GeneratedDomainGraphType.ANTIBODY,
      GeneratedDomainGraphType.CUSTOM_ENTITY,
      GeneratedDomainGraphType.OLIGO_CONJUGATE,
      GeneratedDomainGraphType.OLIGO_DUPLEX,
    ]),
  ],
  ['box', new Set([GeneratedDomainGraphType.BOX])],
  ['boxsch', new Set([GeneratedDomainGraphType.BOX_SCHEMA])],
  ['bsrl', new Set([GeneratedDomainGraphType.BUSINESS_RULE])],
  ['builtinabfmt', new Set([GeneratedDomainGraphType.ANTIBODY_FORMAT])],
  ['chart', new Set([GeneratedDomainGraphType.CHART])],
  ['chtsess', new Set([GeneratedDomainGraphType.CHAT_SESSION])],
  ['clb', new Set([GeneratedDomainGraphType.COLLABORATION])],
  ['con', new Set([GeneratedDomainGraphType.CONTAINER])],
  ['configimphist', new Set([GeneratedDomainGraphType.CONFIG_IMPORT_HISTORY_ENTRY])],
  ['consch', new Set([GeneratedDomainGraphType.CONTAINER_SCHEMA])],
  ['dataset', new Set([GeneratedDomainGraphType.DATASET])],
  ['doc', new Set([GeneratedDomainGraphType.DOCUMENT])],
  ['dset', new Set([GeneratedDomainGraphType.DATA_FRAME])],
  ['ent', new Set([GeneratedDomainGraphType.USER])],
  ['enzl', new Set([GeneratedDomainGraphType.ENZYME_LIST])],
  ['etr', new Set([GeneratedDomainGraphType.ENTRY])],
  ['exmpl', new Set([GeneratedDomainGraphType.EXAMPLE_TYPE])],
  ['featlib', new Set([GeneratedDomainGraphType.FEATURE_LIBRARY])],
  ['file', new Set([GeneratedDomainGraphType.FILE])],
  ['fmdef', new Set([GeneratedDomainGraphType.FORM_DEFINITION])],
  ['intrfc', new Set([GeneratedDomainGraphType.CUSTOM_SCHEMA_INTERFACE])],
  ['ipl', new Set([GeneratedDomainGraphType.INTERNAL_PIPELINE])],
  [
    'jfsch',
    new Set([GeneratedDomainGraphType.BENCHLING_OBJECT_SCHEMA_V2, GeneratedDomainGraphType.JELLYFISH_SCHEMA]),
  ],
  ['jly', new Set([GeneratedDomainGraphType.JELLYFISH])],
  ['lad', new Set([GeneratedDomainGraphType.LADDER])],
  ['lbltmp', new Set([GeneratedDomainGraphType.LABEL_TEMPLATE])],
  ['lib', new Set([GeneratedDomainGraphType.FOLDER])],
  ['loc', new Set([GeneratedDomainGraphType.LOCATION])],
  ['locsch', new Set([GeneratedDomainGraphType.LOCATION_SCHEMA])],
  ['mcpconf', new Set([GeneratedDomainGraphType.MCP_SERVER_CONFIG])],
  ['mdlrun', new Set([GeneratedDomainGraphType.MODEL_RUN])],
  ['mol', new Set([GeneratedDomainGraphType.MOLECULE])],
  ['mxt', new Set([GeneratedDomainGraphType.MIXTURE])],
  ['pardef', new Set([GeneratedDomainGraphType.LIBRARY_PARAMETER_DEFINITION])],
  ['pc', new Set([GeneratedDomainGraphType.PROCEDURE])],
  ['pcfc', new Set([GeneratedDomainGraphType.PROCEDURE_FLOWCHART])],
  ['pcfcv', new Set([GeneratedDomainGraphType.PROCEDURE_FLOWCHART_VERSION])],
  ['pcmdv', new Set([GeneratedDomainGraphType.PROCEDURE_METHOD_DEFINITION_VERSION])],
  ['pcmei', new Set([GeneratedDomainGraphType.PROCEDURE_METHOD_EXECUTION_INSTANCE])],
  ['pcmeiasn', new Set([GeneratedDomainGraphType.PROCEDURE_METHOD_EXECUTION_INSTANCE_ASSOCIATION])],
  ['pcparam', new Set([GeneratedDomainGraphType.PROCEDURE_PARAMETER])],
  ['pcr', new Set([GeneratedDomainGraphType.PROCEDURE_RUN])],
  ['pcrc', new Set([GeneratedDomainGraphType.PROCEDURE_RUN_CONDITION])],
  ['pcrcr', new Set([GeneratedDomainGraphType.PROCEDURE_RUN_CONDITION_REPLICATE])],
  ['pcsdv', new Set([GeneratedDomainGraphType.PROCEDURE_STEP_DEFINITION_VERSION])],
  ['pcsei', new Set([GeneratedDomainGraphType.PROCEDURE_STEP_EXECUTION_INSTANCE])],
  [
    'plt',
    new Set([
      GeneratedDomainGraphType.MATRIX_PLATE,
      GeneratedDomainGraphType.PLATE,
      GeneratedDomainGraphType.WELL_PLATE,
    ]),
  ],
  [
    'pltsch',
    new Set([
      GeneratedDomainGraphType.MATRIX_PLATE_SCHEMA,
      GeneratedDomainGraphType.PLATE_SCHEMA,
      GeneratedDomainGraphType.WELL_PLATE_SCHEMA,
    ]),
  ],
  ['pol', new Set([GeneratedDomainGraphType.POLICY])],
  ['ppvc', new Set([GeneratedDomainGraphType.PROCEDURE_PARAMETER_CONFIRMATION_VALUE])],
  ['ppvm', new Set([GeneratedDomainGraphType.PROCEDURE_PARAMETER_MEASURED_VALUE])],
  ['ppvp', new Set([GeneratedDomainGraphType.PROCEDURE_PARAMETER_PLANNED_VALUE])],
  ['print', new Set([GeneratedDomainGraphType.PRINTER])],
  ['prp', new Set([GeneratedDomainGraphType.PROCEDURE_RUN_PLAN])],
  ['prpc', new Set([GeneratedDomainGraphType.PROCEDURE_RUN_PLAN_CONDITION])],
  ['prs', new Set([GeneratedDomainGraphType.WORKFLOW_TASK_GROUP])],
  ['prsosch', new Set([GeneratedDomainGraphType.WORKFLOW_OUTPUT_SCHEMA])],
  ['prstsch', new Set([GeneratedDomainGraphType.WORKFLOW_TASK_SCHEMA])],
  ['prtn', new Set([GeneratedDomainGraphType.AA_SEQUENCE])],
  ['pubrcrd', new Set([GeneratedDomainGraphType.PUBLISHING_RECORD])],
  ['qnty', new Set([GeneratedDomainGraphType.UNIT_TYPE])],
  ['reqtsksch', new Set([GeneratedDomainGraphType.REQUEST_TASK_SCHEMA])],
  ['result', new Set([GeneratedDomainGraphType.RESULT])],
  ['rqdf', new Set([GeneratedDomainGraphType.REQUEST_V2_DEFINITION])],
  ['rqsm', new Set([GeneratedDomainGraphType.REQUEST_V2_SUBMISSION])],
  ['run', new Set([GeneratedDomainGraphType.RUN])],
  ['sbtmpl', new Set([GeneratedDomainGraphType.ENTRY_SUBTEMPLATE])],
  ['schver', new Set([GeneratedDomainGraphType.PROCEDURE_PARAMETER_VERSION])],
  ['scrfile', new Set([GeneratedDomainGraphType.SCRATCH_FILE])],
  [
    'seq',
    new Set([
      GeneratedDomainGraphType.DNA_OLIGO,
      GeneratedDomainGraphType.DNA_SEQUENCE,
      GeneratedDomainGraphType.RNA_OLIGO,
      GeneratedDomainGraphType.RNA_SEQUENCE,
    ]),
  ],
  ['seqanl', new Set([GeneratedDomainGraphType.NUCLEOTIDE_ALIGNMENT])],
  ['sfs', new Set([GeneratedDomainGraphType.DROPDOWN])],
  ['smpldef', new Set([GeneratedDomainGraphType.SAMPLE_DEFINITION])],
  ['smpltstplan', new Set([GeneratedDomainGraphType.STUDY_SAMPLE_TEST_PLAN])],
  ['smpltyp', new Set([GeneratedDomainGraphType.SAMPLE_TYPE])],
  ['src', new Set([GeneratedDomainGraphType.PROJECT, GeneratedDomainGraphType.REGISTRY])],
  ['ssi', new Set([GeneratedDomainGraphType.STATIC_SCHEMA_INTERFACE])],
  ['star', new Set([GeneratedDomainGraphType.STAR])],
  ['stdy', new Set([GeneratedDomainGraphType.STUDY])],
  ['stdydsgn', new Set([GeneratedDomainGraphType.TRIAL_SAMPLE_TESTING_STUDY_DESIGN])],
  ['stdyitasn', new Set([GeneratedDomainGraphType.STUDY_ITEM_ASSOCIATION])],
  ['stdysch', new Set([GeneratedDomainGraphType.STUDY_SCHEMA])],
  ['stgentr', new Set([GeneratedDomainGraphType.STAGE_ENTRY])],
  ['svdrltmpl', new Set([GeneratedDomainGraphType.STATIC_VALIDATION_RULE_TEMPLATE])],
  ['tcfg', new Set([GeneratedDomainGraphType.TENANT_CONFIG])],
  ['tdef', new Set([GeneratedDomainGraphType.TEST_DEFINITION])],
  ['team', new Set([GeneratedDomainGraphType.TEAM])],
  ['tgsch', new Set([GeneratedDomainGraphType.BENCHLING_OBJECT_SCHEMA_V2])],
  ['tmpl', new Set([GeneratedDomainGraphType.ENTRY_TEMPLATE])],
  ['tmplcol', new Set([GeneratedDomainGraphType.TEMPLATE_COLLECTION])],
  ['tntcl', new Set([GeneratedDomainGraphType.TENTACLE])],
  ['tord', new Set([GeneratedDomainGraphType.TEST_ORDER])],
  ['trtmntgrp', new Set([GeneratedDomainGraphType.TREATMENT_GROUP])],
  [
    'ts',
    new Set([
      GeneratedDomainGraphType.AA_SEQUENCE_SCHEMA,
      GeneratedDomainGraphType.DNA_SEQUENCE_SCHEMA,
      GeneratedDomainGraphType.ENTITY_SCHEMA,
    ]),
  ],
  ['unit', new Set([GeneratedDomainGraphType.UNIT])],
  ['vdrl', new Set([GeneratedDomainGraphType.VALIDATION_RULE])],
  ['wffcc', new Set([GeneratedDomainGraphType.WORKFLOW_FLOWCHART_CONFIG])],
  [
    'wffccv',
    new Set([
      GeneratedDomainGraphType.PROCEDURE_FLOWCHART_CONFIG_VERSION_PROXY,
      GeneratedDomainGraphType.WORKFLOW_FLOWCHART_CONFIG_VERSION,
    ]),
  ],
  ['wffcec', new Set([GeneratedDomainGraphType.WORKFLOW_FLOWCHART_EDGE_CONFIG])],
  ['wffnc', new Set([GeneratedDomainGraphType.WORKFLOW_FLOWCHART_NODE_CONFIG])],
  ['wfond', new Set([GeneratedDomainGraphType.WORKFLOW_OUTPUT_NODE_DETAILS])],
  ['wfout', new Set([GeneratedDomainGraphType.WORKFLOW_OUTPUT])],
  ['wfrf', new Set([GeneratedDomainGraphType.WORKFLOW_ROUTER_FUNCTION])],
  ['wfrnd', new Set([GeneratedDomainGraphType.WORKFLOW_ROUTER_NODE_DETAILS])],
  ['wfrtnd', new Set([GeneratedDomainGraphType.WORKFLOW_ROOT_NODE_DETAILS])],
  ['wftask', new Set([GeneratedDomainGraphType.WORKFLOW_TASK])],
  ['wftdef', new Set([GeneratedDomainGraphType.WORKFLOW_TASK_DEFINITION])],
  ['wftdefv', new Set([GeneratedDomainGraphType.WORKFLOW_TASK_DEFINITION_VERSION])],
  ['wftnd', new Set([GeneratedDomainGraphType.WORKFLOW_TASK_NODE_DETAILS])],
  ['wftrnd', new Set([GeneratedDomainGraphType.WORKFLOW_END_NODE_DETAILS])],
  ['wkl', new Set([GeneratedDomainGraphType.WORKLIST])],
  ['wks', new Set([GeneratedDomainGraphType.WORKSHEET])],
] as const;

/** @package */
export const ID_PREFIX_TO_DOMAIN_GRAPH_TYPES: Record<CoreObjectIdPrefix, Set<ObjectType>> = objectFromEntries(
  ID_PREFIX_TO_DOMAIN_GRAPH_TYPES_ENTRIES as unknown as Array<[CoreObjectIdPrefix, Set<ObjectType>]>
);
